<template>
    <layout v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="saveItem">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{pageTitle}} - {{ form.title }}</h1>
                        </div>
                    </div>
                    <div class="row" v-if="form.resources_count>0">
                        <div class="col">
                            <p class="info-text">{{resourcesInfo}}</p>
                        </div>
                    </div>
                    <div class="row" v-if="form.resources_count>0">
                        <div class="col">
                            <table-data
                                :route="url.getHarvest.replace(':id', this.$route.params.id)"
                                :settings="table.settings"
                                :columns="table.columns"
                                :inlineFilters="table.filters"
                                :autoUpdateFilter="table.autoUpdateFilter"
                                :addParamsToUrl="table.addParamsToUrl"
                                :loadingMsg="table.loadingMsg"
                                :notFoundMsg="table.notFoundMsg"
                                :orderByTemplate="table.orderByTemplate"
                                tableClass="table-responsive-sm"
                                @error-load="showError"
                                @on-selected-rows-change="selectionChanged"
                                :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'mb-1',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    disableSelectInfo: false, // disable the select info panel on top
                                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                                }"
                            >
                                <template v-slot:body="{row}">
                                    <td :class="table.columns[0].class">{{row[table.columns[0].field]}}</td>
                                    <td :class="table.columns[1].class">{{row[table.columns[1].field]}}</td>
                                    <td :class="table.columns[2].class">{{row[table.columns[2].field]}}</td>
                                </template>
                            </table-data>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col">
                            <p class="info-text">{{allResourcesImported}}</p>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem && form.resources_count>0"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="form.lyrsids==0"
                        @save="linkResources"
                        @cancel="handleBack(`${moduleCode}.${pageID}.view`, true)"
                    >
                    </buttons-footer>
                </form>
            </div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
        components: {
        },
    	data() {
      		return {
      			pageID: 'ogc_remote_services',
                pageTitle: 'Import resources',
                notFound: 'Could not contact',
                allResourcesImported: 'All resources have already been imported',
                submitTitle: 'Import Resources',
                resourcesText: 'resources can be imported',
                selectedRows: 0,
                form: {
                    id: null,
                    title: null,
                    description: null,
                    abstract: null,
                    keywords: null,
                    layers_count: 0,
                    resources_count: 0,
                    lyrsids: [],
                },
                table: {
                    settings: {
                        order_by: 'title',
                    },
                    columns: [
                        {
                            label: 'Id',
                            field: 'layers',
                            class: 'text-break',
                            // thClass: '',
                            // tdClass: 'text-center',
                            sortable: true,
                        },
                        {
                            label: 'Title',
                            field: 'title',
                            class: 'text-break',
                            // thClass: '',
                            // tdClass: 'text-center',
                            sortable: true,
                        },
                        {
                            label: 'Description',
                            field: 'abstract',
                            class: 'text-break',
                            // thClass: '',
                            // tdClass: 'text-center',
                            sortable: false,
                        }
                    ],
                },
      		}
    	},
        computed: {
            resourcesInfo() {
                return `${this.form.resources_count} ${this.resourcesText}`;
            },
        },
        mounted() {

        },
    	methods: {
            selectionChanged(evt) {
                this.form.lyrsids = evt.selectedRows;
            },
            linkResources() {
                if(this.canHarvest) {
                    this.saveItem(`${this.moduleCode}.${this.pageID}.view`);
                }
            },
    	}
  	}
</script>

<style scoped lang="scss">
    @import "@styles/bootstrap/_mixins.scss";
    .info-text {
        @include font-size(18px);
        line-height: 1.63;
        opacity: 0.6;
    }
</style>

